<div class='{{s.css + " " + (prefix + s.id) }}' *ngFor="let s of sizes"></div>
